// Static data for the Azaziya Agency website

export const globalData = {
  "logo": {
    "useSvg": true,
    "src": "/images/logo.svg",
    "text": "AZAZI",
    "boldText": "YA",
    "alt": "Azaziya International",
    "link": "/"
  },
  "navLinks": [
    {
      "_key": "0f1c45a5019e",
      "href": "/",
      "key": "home",
      "label": "Home"
    },
    {
      "_key": "2292cfca2575",
      "href": "/about",
      "key": "about",
      "label": "About"
    },
    {
      "_key": "0db8e7e9a6fd",
      "href": "/services",
      "key": "services",
      "label": "Services"
    },
    {
      "_key": "ae953412cb98",
      "href": "/team",
      "key": "team",
      "label": "Team"
    },
    {
      "_key": "b1a3daec6217",
      "href": "/blog",
      "key": "blog",
      "label": "Blog"
    },
    {
      "_key": "60b9e3fbd69d",
      "href": "/contact",
      "key": "contact",
      "label": "Contact"
    }
  ],
  "headerCta": {
    "label": "Free Strategy Session",
    "href": "/contact"
  },
  "footer": {
    "description": "Azaziya International is a creative design and digital solutions company helping businesses across Dubai and Saudi Arabia look sharper, stand stronger, and communicate with impact.",
    "socials": [
      {
        "_key": "f997358e7f52",
        "label": "IG",
        "name": "Instagram",
        "url": "[https://www.instagram.com/azaziya](https://www.instagram.com/azaziya)"
      },
      {
        "_key": "1a339407ddbb",
        "label": "IN",
        "name": "LinkedIn",
        "url": "[https://www.linkedin.com/company/azaziya](https://www.linkedin.com/company/azaziya)"
      },
      {
        "_key": "3eddffdd5cbe",
        "label": "FB",
        "name": "Facebook",
        "url": "[https://www.facebook.com/azaziya](https://www.facebook.com/azaziya)"
      },
      {
        "_key": "ec78f82f0fd7",
        "label": "WA",
        "name": "WhatsApp",
        "url": "[https://wa.me/923138166979](https://wa.me/923138166979)"
      }
    ],
    "contact": {
      "email": "info@azaziya.com",
      "phone": "+92 313 8166979",
      "location": "Karachi, Pakistan",
      "locationLink": "#"
    },
    "ctaLabel": "Get Free Consultation",
    "copyright": "Azaziya International. All rights reserved.",
    "links": [
      {
        "_key": "links-0",
        "href": "/terms",
        "label": "Terms & Conditions"
      },
      {
        "_key": "links-1",
        "href": "/terms#privacy",
        "label": "Privacy Policy"
      }
    ]
  },
  "breadcrumbs": {
    "home": "Home",
    "homeLink": "/"
  }
};

export const homeData = {
  "hero": {
    "tagline": "Choosing the Right Digital Partner.",
    "titleStart": "Every Successful Business Starts With",
    "titleAccent": "One Powerful Decision.",
    "subtitle": "Azaziya is a creative agency helping ambitious businesses grow through strategic branding, SEO, web development, video animation, and performance driven digital marketing.",
    "ctaPrimaryText": "Start Your Growth Journey",
    "ctaPrimaryLink": "/contact",
    "ctaSecondaryText": "Explore Our Services",
    "ctaSecondaryLink": "/services",
    "stats": [
      {
        "_key": "e5c999a75ccf",
        "count": "15",
        "label": "Industries Served",
        "suffix": "+"
      },
      {
        "_key": "e12c301faca9",
        "count": "6",
        "label": "Core Services",
        "suffix": null
      },
      {
        "_key": "1d30c16f2d39",
        "count": "70",
        "label": "Avg. Engagement Lift",
        "suffix": "%"
      }
    ]
  },
  "marquee": [
    "3D Exhibition Stand Design",
    "3D exhibition & Event Design",
    "Web Development",
    "Branding",
    "Video Animation",
    "Social Media Marketing",
    "SEO & AEO"
  ],
  "about": {
    "eyebrow": "About Us",
    "heading": "Where Ideas Take Shape",
    "image": "/images/about.jpg",
    "paragraphs": [
      "AZAZIYA isn't just an agency. It's a creative engine, built for brands that don't want to blend in.",
      "We fuse strategy, design, and technology into one force: 3D Exhibition & Events Design, Web Development, Branding, Video-Animation ,   SEO & AI Solutions, and Digital Marketing experiences, all under one roof, one vision, one team.",
      "AZAZIYA was born from a simple truth: great brands aren't built in silos. A website without strategy is just pixels. An event without execution is just noise. So we built something different, a studio where every discipline works in sync, driven by one goal: make brands impossible to ignore.",
      "Today, we partner with bold, ambitious names across the UAE, UK, and USA, helping them move sharper, faster, and louder in a world that never stops scrolling."
    ],
    "buttonText": "More About Azaziya",
    "buttonLink": "/about"
  },
  "servicesHead": {
    "eyebrow": "What We Do",
    "heading": "Six Disciplines. One Growth Engine.",
    "paragraph": "From first impression to first sale Azaziya builds the brand, the platform, and the marketing engine that gets your business found, trusted, and chosen."
  },
  "servicesList": [
    {
      "num": "01",
      "title": "3D Exhibition & Events Design",
      "link": "/services/3d-event-design",
      "description": "Photorealistic 3D visualisation of exhibition stands, stages and booths before fabrication begins."
    },
    {
      "num": "02",
      "title": "Web Development",
      "link": "/services/web-development",
      "description": "Fast, SEO-optimised, conversion-focused websites corporate, e-commerce, landing pages and CMS."
    },
    {
      "num": "03",
      "title": "Branding Services",
      "link": "/services/branding",
      "description": "Brand strategy, logo design, visual identity systems, brand guidelines, corporate branding and rebranding."
    },
    {
      "num": "04",
      "title": "Video Animation",
      "link": "/services/video-animation",
      "description": "2D & 3D animation, motion graphics, explainer and corporate videos built from scratch, never templates."
    },
    {
      "num": "05",
      "title": "Social Media Marketing",
      "link": "/services/digital-marketing",
      "description": "ROI-driven strategy, management, advertising and content creation across every major platform."
    },
    {
      "num": "06",
      "title": "SEO & AEO",
      "link": "/services/seo-ai-solutions",
      "description": "Technical SEO, Local SEO, and Answer Engine Optimisation for Google and AI-powered search."
    }
  ],
  "whyChoose": {
    "eyebrow": "Why Azaziya",
    "heading": "Why AZAZIYA",
    "items": [
      "Based in Pakistan, at the pulse of one of the world's fastest-moving business hubs, we don't follow trends. We build ahead of them.",
      "Every project starts with one question: what does this brand need to win? Not a template. Not a formula. A real strategy, built for real impact.",
      "Creative instinct. Technical precision. Zero compromise."
    ]
  },
  "teamHead": {
    "eyebrow": "Meet Our Team",
    "heading": "The Experts Behind Azaziya's Creative Success",
    "paragraph": "Our talented team combines creativity, strategy, and technical expertise to deliver exceptional digital solutions for businesses across Dubai and Saudi Arabia. From branding and web development to SEO, motion graphics, and digital marketing, we work together to help your business grow with confidence.",
    "buttonText": "Meet The Full Team",
    "buttonLink": "/team"
  },
  "teamList": [
    {
      "initials": "SM",
      "name": "Saqib Modelista",
      "role": "Founder & CEO",
      "description": "Leading Azaziya with a vision for innovation, business growth, and client success. Our CEO ensures every project is driven by strategy, creativity, and measurable results."
    },
    {
      "initials": "MH",
      "name": "Muhammad Hamza",
      "role": "Brand Manager",
      "description": "Manages the brand identity, visual design, and overall brand strategy for Azaziya and its clients."
    },
    {
      "initials": "ZZ",
      "name": "Zaid Zulfiqar",
      "role": "Creative Head",
      "description": "Manages the creative strategy, visual design, and overall creative direction for Azaziya and its clients."
    },
    {
      "initials": "ZA",
      "name": "Zain Arisar",
      "role": "Digital Growth Manager",
      "description": "Manages the digital growth strategy for Azaziya and its clients."
    }
  ],
  "ctaBand": {
    "eyebrow": "Let's Talk",
    "heading": "Ready to Turn Your Idea Into a Brand Customers Trust?",
    "paragraph": "Book a free strategy session and discover exactly how Azaziya can grow your business across Dubai and Saudi Arabia.",
    "primaryText": "Start Your Growth Journey",
    "primaryLink": "/contact",
    "secondaryText": "Explore Our Services",
    "secondaryLink": "/services"
  }
};

export const aboutData = {
  "hero": {
    "breadcrumbText": "About Us",
    "eyebrow": "Who We Are",
    "heading": "Where Strategy Meets Craft",
    "lead": "Azaziya is a full-service creative agency . We help brands build clarity, gain trust, and scale across digital touchpoints."
  },
  "whoWeAre": {
    "eyebrow": "Our Story",
    "heading": "Built for Brands That Demand Growth",
    "image": "/images/about-office.jpg",
    "paragraphs": [
      "AZAZIYA isn't just an agency. It's a creative engine, built for brands that don't want to blend in.",
      "We fuse strategy, design, and technology into one force: 3D Exhibition & Events Design, Web Development, Branding, Video-Animation ,   SEO & AI Solutions, and Digital Marketing experiences, all under one roof, one vision, one team.",
      "AZAZIYA was born from a simple truth: great brands aren't built in silos. A website without strategy is just pixels. An event without execution is just noise. So we built something different, a studio where every discipline works in sync."
    ]
  },
  "mission": {
    "eyebrow": "Core Values",
    "heading": "The Principles That Guide Us",
    "items": [
      {
        "_key": "2d651db5f639",
        "description": "Every line of code, design asset, and marketing campaign starts with a clear business purpose.",
        "num": "01",
        "title": "Strategic Clarity"
      },
      {
        "_key": "85e979065273",
        "description": "We deliver high-precision execution across web design, motion animation, and brand identity.",
        "num": "02",
        "title": "Uncompromising Craft"
      },
      {
        "_key": "d7990d9b9268",
        "description": "Honest communication, clear timelines, and measurable targets for every single client engagement.",
        "num": "03",
        "title": "Full Transparency"
      },
      {
        "_key": "e9a555c60632",
        "description": "Staying ahead with AI integration, AEO search strategies, and modern web frameworks.",
        "num": "04",
        "title": "Future-Ready Innovation"
      }
    ]
  },
  "deliver": {
    "eyebrow": "Capabilities",
    "heading": "Comprehensive Digital & Creative Solutions",
    "tags": [
      "3D exhibition & Event Design",
      "Web Development",
      "Branding & Marketing",
      "Video Animation",
      "SEO & AEO",
      "Social Media Marketing"
    ]
  },
  "ctaBand": {
    "eyebrow": "Work With Us",
    "heading": "Ready to Transform Your Digital Presence?",
    "primaryText": "Get Started Today",
    "primaryLink": "/contact",
    "secondaryText": "Explore Our Services",
    "secondaryLink": "/services"
  }
};

export const servicesData = {
  "hero": {
    "breadcrumbText": "Services",
    "eyebrow": "Our Expertise",
    "heading": "6 Disciplines. 1 Growth Engine.",
    "lead": "We craft custom digital platforms, distinct brand identities, and high-impact visual experiences tailored for businesses in Dubai and Saudi Arabia.",
    "portfolioBtnText": "Portfolio",
    "portfolioBtnLink": "/portfolio"
  },
  "servicesGrid": [
    {
      "num": "01",
      "title": "3D Exhibition & Event Design",
      "link": "/services/3d-event-design",
      "description": "Photorealistic 3D visualisation of exhibition stands, stages and booths before fabrication begins.",
      "bullets": [
        "3D Exhibition Stand Design",
        "Event Stage Design",
        "Trade Show Booth Design",
        "Brand Activation Design"
      ]
    },
    {
      "num": "02",
      "title": "Web Development",
      "link": "/services/web-development",
      "description": "Fast, SEO-optimised, conversion-focused websites corporate, e-commerce, landing pages and CMS.",
      "bullets": [
        "Custom Website Development",
        "E-commerce (Shopify, Woo)",
        "Landing Pages for Ads",
        "Website Redesign & Speed"
      ]
    },
    {
      "num": "03",
      "title": "Branding Services",
      "link": "/services/branding",
      "description": "Brand strategy, logo design, visual identity systems, brand guidelines, corporate branding and rebranding.",
      "bullets": [
        "Brand Strategy & Positioning",
        "Logo & Visual Identity",
        "Brand Guidelines",
        "Corporate & Rebranding"
      ]
    },
    {
      "num": "04",
      "title": "Video Animation",
      "link": "/services/video-animation",
      "description": "2D & 3D animation, motion graphics, explainer and corporate videos built from scratch, never templates.",
      "bullets": [
        "2D Animation Videos",
        "3D Animation Services",
        "Motion Graphics Design",
        "Explainer Video Production"
      ]
    },
    {
      "num": "05",
      "title": "Social Media Marketing",
      "link": "/services/digital-marketing",
      "description": "ROI-driven strategy, management, advertising and content creation across every major platform.",
      "bullets": [
        "Social Media Management",
        "Paid Social Advertising",
        "Content Creation & Branding",
        "Platform-Specific Marketing"
      ]
    },
    {
      "num": "06",
      "title": "SEO & AEO",
      "link": "/services/seo-ai-solutions",
      "description": "Technical SEO, Local SEO, and Answer Engine Optimisation for Google and AI-powered search.",
      "bullets": [
        "Search Engine Optimisation",
        "Answer Engine Optimisation",
        "Local SEO",
        "Authority & Content Strategy"
      ]
    }
  ],
  "experience": {
    "eyebrow": "Our Experience",
    "heading": "Custom Strategy for Every Industry, Not a One-Size-Fits-All Package",
    "tags": [
      "Healthcare",
      "Real Estate",
      "Construction",
      "Restaurants",
      "Hospitality",
      "Fashion",
      "Retail",
      "Education",
      "Finance",
      "Technology",
      "Automotive",
      "Manufacturing",
      "E-commerce",
      "Startups",
      "Corporate Businesses"
    ]
  },
  "ctaBand": {
    "eyebrow": "Ready to Scale?",
    "heading": "Let’s build something extraordinary together.",
    "primaryText": "Get in Touch",
    "primaryLink": "/contact"
  }
};

export const teamData = {
  "hero": {
    "breadcrumbText": "Our Team",
    "eyebrow": "Meet The Team",
    "heading": "The Experts Behind Azaziya's Creative Success",
    "lead": "Our talented team combines creativity, strategy, and technical expertise to deliver exceptional digital solutions for businesses across Dubai and Saudi Arabia. From branding and web development to SEO, motion graphics, and digital marketing, we work together to help your business grow with confidence."
  },
  "teamList": [
    {
      "initials": "SM",
      "name": "Saqib Modelista",
      "role": "Founder & CEO",
      "description": "Leading Azaziya with a vision for innovation, business growth, and client success. Our CEO ensures every project is driven by strategy, creativity, and measurable results."
    },
    {
      "initials": "MH",
      "name": "Muhammad Hamza",
      "role": "Brand Designer",
      "description": "Creating unique brand identities, logos, and visual designs that help businesses build recognition, trust, and a lasting impression."
    },
    {
      "initials": "ZZ",
      "name": "Zaid Zulfiqar",
      "role": "Creative Head",
      "description": "A creative professional who leads and oversees all creative aspects of a business or project. Responsible for developing and executing creative strategies, concepts, and initiatives to achieve business goals and enhance brand presence."
    },
    {
      "initials": "ZA",
      "name": "Zain Arisar",
      "role": "Digital Growth Manager",
      "description": "A digital marketing strategist who helps businesses achieve measurable growth through data-driven insights, targeted campaigns, and cutting-edge technology.",
    }
  ],
  "ctaBand": {
    "heading": "Together, We Are Committed to Delivering Creative, Results-Driven Digital Solutions That Help Businesses Succeed in Today's Competitive Market.",
    "primaryText": "Work With Our Team",
    "primaryLink": "/contact"
  }
};

export const blogData = {
  "hero": {
    "breadcrumbText": "Blog",
    "eyebrow": "Azaziya Insights",
    "heading": "Ideas on Branding, Web, SEO & Marketing for UAE Businesses",
    "lead": "Practical guides from our team on building brands, websites, and campaigns that actually grow a business in competitive market."
  },
  "ctaBand": {
    "eyebrow": "Have a Project in Mind?",
    "heading": "Let's Turn These Ideas Into Your Next Result.",
    "headingSub": "Let's Turn These Ideas Into Your Next Result.",
    "primaryText": "Start Your Grow Journey",
    "primaryLink": "/contact"
  }
};

export const contactData = {
  "hero": {
    "breadcrumbText": "Contact Us",
    "eyebrow": "Get In Touch",
    "heading": "Let's Build Something Great Together.",
    "lead": "Have a project in mind, need a consultation, or want to discuss a tailored growth strategy? Send us a message or connect directly."
  },
  "details": {
    "eyebrow": "Contact Details",
    "heading": "We'd Love to Hear From You",
    "description": "Whether it's branding, a website, an exhibition stand, or an SEO audit reach out and our team will respond within one business day.",
    "items": [
      {
        "label": "Email",
        "val": "info@azaziya.com",
        "type": "email"
      },
      {
        "label": "Phone",
        "val": "+92 3138166979",
        "type": "phone"
      },
      {
        "label": "Location",
        "val": "Karachi, Pakistan",
        "type": "text"
      },
      {
        "label": "WhatsApp",
        "val": "Connect With Us",
        "type": "link",
        "href": "https://wa.me/923138166979"
      }
    ]
  },
  "form": {
    "formspreeId": "xykabbyd",
    "successMsg": "Thank you! Your message has been received. Our team will get back to you within one business day.",
    "labels": {
      "name": "Full Name",
      "namePlaceholder": "Your name",
      "email": "Email Address",
      "emailPlaceholder": "you@company.com",
      "phone": "Phone Number",
      "phonePlaceholder": "+971",
      "service": "Service Needed",
      "message": "Tell Us About Your Project",
      "messagePlaceholder": "Share your goals, timeline, and any details that would help us prepare.",
      "submit": "Send Message"
    },
    "services": [
      "3D Exhibition & Event Design",
      "Web Development",
      "Branding",
      "Video Animation",
      "Social Media Marketing",
      "SEO & AEO",
      "Something Else"
    ]
  }
};

export const termsData = {
  "hero": {
    "breadcrumbText": "Terms & Conditions",
    "eyebrow": "Legal",
    "heading": "Terms & Conditions",
    "lead": "Please read these Terms and Conditions carefully before using the services provided by Azaziya International."
  },
  "tocTitle": "On This Page",
  "toc": [
    {
      "href": "#agreement",
      "text": "1. Agreement to Terms"
    },
    {
      "href": "#services",
      "text": "2. Services"
    },
    {
      "href": "#quotes",
      "text": "3. Quotes, Payments & Fees"
    },
    {
      "href": "#revisions",
      "text": "4. Revisions & Approvals"
    },
    {
      "href": "#ip",
      "text": "5. Intellectual Property"
    },
    {
      "href": "#content",
      "text": "6. Client-Provided Content"
    },
    {
      "href": "#website-use",
      "text": "7. Website Use"
    },
    {
      "href": "#liability",
      "text": "8. Limitation of Liability"
    },
    {
      "href": "#termination",
      "text": "9. Termination"
    },
    {
      "href": "#governing-law",
      "text": "10. Governing Law"
    },
    {
      "href": "#privacy",
      "text": "11. Privacy Policy"
    },
    {
      "href": "#changes",
      "text": "12. Changes to These Terms"
    },
    {
      "href": "#contact-us",
      "text": "13. Contact Us"
    }
  ],
  "sections": [
    {
      "_key": "76b56059a325",
      "content": "These Terms & Conditions (\"Terms\") govern your access to and use of the Azaziya International website (the \"Site\") and any services provided by Azaziya International (\"Azaziya\", \"we\", \"us\", or \"our\"), including but not limited to branding, social media marketing, web development, 3D exhibition & event   design, video animation, and SEO services. By accessing the Site or engaging our services, you agree to be bound by these Terms. If you do not agree, please discontinue use of the Site and our services.",
      "heading": "1. Agreement to Terms",
      "id": "agreement",
      "paragraphs": [
        "Welcome to Azaziya International (\"Company\", \"we\", \"our\", \"us\"). By accessing or using our website, services, or engaging with our digital solutions, you agree to be bound by these Terms and Conditions.",
        "If you do not agree with any part of these terms, you must not use our website or services."
      ],
      "title": "1. Introduction"
    },
    {
      "_key": "94acf6ba2c48",
      "content": "Azaziya provides creative design and digital solutions, including branding, logo design, visual identity, social media management and advertising, website and e-commerce development, 3D exhibition and event design, video and motion animation, and search engine optimisation (SEO), Answer Engine Optimisation (AEO) and Local SEO services. The exact scope, deliverables, timeline, and pricing for any project will be confirmed in a separate written proposal, quotation, or agreement between Azaziya and the client prior to commencement of work.",
      "heading": "2. Services",
      "id": "services",
      "paragraphs": [
        "Azaziya International provides digital solutions, including web development, branding, 3D exhibition & Event Design, video animation, SEO, and social media marketing.",
        "All project deliverables, timelines, and payment terms will be agreed upon in a separate service agreement or project proposal prior to starting work."
      ],
      "title": "2. Services & Scope of Work"
    },
    {
      "_key": "e07a41f50a16",
      "heading": "3. Quotes, Payments & Fees",
      "id": "quotes",
      "list": [
        "All quotations provided are estimates based on the information available at the time and may be revised if project scope changes.",
        "An advance payment or deposit may be required before work begins on a project.",
        "Remaining balances are due according to the payment schedule agreed in the project proposal or invoice.",
        "Late payments may result in a pause of ongoing work until outstanding amounts are settled.",
        "Prices for services such as 3D exhibition & Event Design, branding, and animation vary based on scope, complexity, and delivery timeline, as outlined on the relevant service pages."
      ],
      "paragraphs": [
        "All content, source code, visual designs, and brand assets created by Azaziya International remain our intellectual property until all agreed invoice payments have been settled in full.",
        "Upon full payment, ownership rights for final deliverables are transferred to the client as specified in the service contract."
      ],
      "title": "3. Intellectual Property Rights"
    },
    {
      "_key": "ffef18c27672",
      "content": "Each service includes a defined number of revision rounds as agreed in the project scope. Additional revisions beyond the agreed rounds may incur extra charges. Final files, designs, or website launches will only proceed once written approval has been received from the client.",
      "heading": "4. Revisions & Approvals",
      "id": "revisions",
      "paragraphs": [
        "Azaziya International shall not be liable for any indirect, incidental, or consequential damages resulting from the use or inability to use our services or website.",
        "We make reasonable efforts to ensure accuracy and high performance across all deliverables, but we do not guarantee third-party platform uptime, API changes, or algorithm updates beyond our direct control."
      ],
      "title": "4. Limitation of Liability"
    },
    {
      "_key": "3723e4968377",
      "content": "Upon full payment, ownership of the final approved deliverables (such as logos, brand assets, website code, or animation files) transfers to the client, unless otherwise agreed in writing. Azaziya retains the right to showcase completed work in its portfolio, case studies, and marketing materials unless the client requests confidentiality in writing. Any third-party assets used (stock imagery, fonts, plugins, or licensed software) remain subject to their original licensing terms.",
      "heading": "5. Intellectual Property",
      "id": "ip",
      "paragraphs": [
        "These Terms and Conditions are governed by and construed in accordance with the laws of Dubai and the United Arab Emirates.",
        "Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Dubai, UAE."
      ],
      "title": "5. Governing Law"
    },
    {
      "_key": "6d0279244d17",
      "content": "Clients are responsible for ensuring that any content, images, logos, trademarks, or data they provide to Azaziya do not infringe on the rights of any third party. Azaziya is not liable for any claims arising from client-supplied material used in a project.",
      "heading": "6. Client-Provided Content",
      "id": "content",
      "paragraphs": [
        "If you have any questions regarding these Terms & Conditions, please contact us at hello@azaziya.com."
      ],
      "title": "6. Contact Us"
    }
  ],
  "ctaBand": {
    "heading": "Have a Question About Working With Us?",
    "btnText": "Contact Azaziya",
    "btnLink": "/contact"
  }
};

export const servicesDetailData = {
  "branding": {
    "eyebrow": "Service 01 - Branding",
    "title": "Branding Services in Dubai, UAE | Build a Brand That Customers Remember",
    "lead": "Your brand is much more than a logo. It is the story people remember, the emotions they associate with your business, and the trust that influences buying decisions.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "Branding",
    "ctaLabel": "Start Your Branding Project",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/branding",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "",
    "pricePlanImage": "",
    "split": {
      "eyebrow": "Create a Powerful Brand Identity",
      "title": "Branding That Drives Business Growth",
      "image": "/images/about-sketch.jpg",
      "paragraphs": [
        "At Azaziya, we help businesses across Dubai and Saudi Arabia build memorable brands that stand out in competitive markets. From brand strategy and logo design to complete visual identity systems, we create brands that connect with customers and support long-term growth.",
        "Whether you're launching a startup, rebranding an established company, or expanding into new markets, our branding specialists transform your vision into a professional brand identity that builds recognition, trust, and customer loyalty."
      ],
      "shape": "triangle"
    },
    "whyItMatters": {
      "eyebrow": "Why It Matters",
      "title": "Why Branding Matters for Your Business",
      "description": "Today's customers don't simply buy products or services they buy brands they recognize and trust. A strategic branding process helps your business:",
      "checks": [
        "Increase Brand Recognition",
        "Build Customer Trust",
        "Stand Out From Competitors",
        "Improve Customer Loyalty",
        "Create Consistent Marketing",
        "Increase Business Value",
        "Generate More Qualified Leads",
        "Support Long-Term Business Growth"
      ],
      "outro": "A professionally developed brand gives your business a competitive advantage in Dubai's fast-moving marketplace.",
      "cards": []
    },
    "ourServices": {
      "eyebrow": "Our Branding Services",
      "title": "Everything Your Brand Identity Needs",
      "cards": [
        {
          "title": "Brand Strategy",
          "desc": "Every successful brand starts with strategy. We research your market, competitors, audience, and business goals to create a unique positioning that differentiates your company.",
          "bullets": [
            "Brand Discovery",
            "Market Research",
            "Brand Positioning",
            "Mission & Vision",
            "Brand Values",
            "Customer Persona",
            "Brand Personality",
            "Messaging Strategy"
          ]
        },
        {
          "title": "Logo Design",
          "desc": "A memorable logo is the foundation of your visual identity. Our designers create timeless, scalable logos that communicate professionalism and reflect your business values.",
          "bullets": [
            "Primary Logo",
            "Secondary Logo",
            "Icon Design",
            "Logo Variations",
            "Color Versions",
            "File Formats"
          ]
        },
        {
          "title": "Visual Identity Design",
          "desc": "We create a complete visual system that keeps your business consistent across every customer touchpoint.",
          "bullets": [
            "Typography",
            "Brand Colors",
            "Icons",
            "Graphic Elements",
            "Photography Style",
            "Social Media Templates",
            "Presentation Templates"
          ]
        },
        {
          "title": "Brand Guidelines",
          "desc": "Maintain consistency with comprehensive brand guidelines. Your team will know exactly how to use every branding element correctly.",
          "bullets": [
            "Logo Usage",
            "Color Codes",
            "Typography Rules",
            "Spacing",
            "Design Standards",
            "Brand Voice",
            "Communication Guidelines"
          ]
        },
        {
          "title": "Corporate Branding",
          "desc": "Professional branding solutions for growing companies.",
          "bullets": [
            "Business Cards",
            "Letterheads",
            "Email Signatures",
            "Company Profile",
            "Presentation Decks",
            "Office Branding",
            "Vehicle Branding",
            "Merchandise"
          ]
        },
        {
          "title": "Rebranding Services",
          "desc": "Is your current brand outdated? Our rebranding experts modernize your identity while preserving the trust you've already built. Perfect for businesses experiencing:",
          "bullets": [
            "Market Expansion",
            "Business Growth",
            "New Target Audience",
            "Brand Refresh",
            "Company Merger",
            "Digital Transformation"
          ]
        }
      ]
    },
    "process": {
      "eyebrow": "How We Work",
      "title": "Our Branding Process",
      "steps": [
        {
          "_key": "process-step-0",
          "desc": "Understanding your business, audience, goals, and competitors.",
          "num": "01",
          "title": "Discovery"
        },
        {
          "_key": "process-step-1",
          "desc": "Market analysis and positioning strategy.",
          "num": "02",
          "title": "Research"
        },
        {
          "_key": "process-step-2",
          "desc": "Developing your brand foundation.",
          "num": "03",
          "title": "Brand Strategy"
        },
        {
          "_key": "process-step-3",
          "desc": "Creating visual identity and logo concepts.",
          "num": "04",
          "title": "Design"
        },
        {
          "_key": "process-step-4",
          "desc": "Building consistency across every platform.",
          "num": "05",
          "title": "Brand Guidelines"
        },
        {
          "_key": "process-step-5",
          "desc": "Helping your new brand enter the market with confidence.",
          "num": "06",
          "title": "Launch"
        }
      ]
    },
    "whyUs": {
      "eyebrow": "Why Choose Azaziya",
      "title": "What Makes Us Different",
      "description": "Businesses across Dubai choose Azaziya because we combine strategic thinking with creative execution.",
      "checks": [
        "Strategy Before Design",
        "Business-Focused Branding",
        "Experienced Creative Team",
        "Modern Design Standards",
        "Complete Brand Systems",
        "UAE Market Understanding",
        "Transparent Communication",
        "On-Time Delivery",
        "Scalable Branding Solutions"
      ]
    },
    "sectors": {
      "eyebrow": "Industries We Serve",
      "title": "Branding Solutions Across Every Sector",
      "tags": [
        "Healthcare",
        "Real Estate",
        "Construction",
        "Restaurants",
        "Hospitality",
        "Fashion",
        "Retail",
        "Education",
        "Finance",
        "Technology",
        "Automotive",
        "Manufacturing",
        "E-commerce",
        "Startups",
        "Corporate Businesses"
      ]
    },
    "faqsTitle": "Frequently Asked Questions",
    "faqsEyebrow": "FAQs",
    "faqs": [
      {
        "q": "What is included in branding services?",
        "a": "Branding services typically include brand strategy, logo design, visual identity, messaging, brand guidelines, and marketing assets."
      },
      {
        "q": "How long does a branding project take?",
        "a": "Most branding projects are completed within 2–6 weeks, depending on the scope and complexity."
      },
      {
        "q": "Do you provide logo design only?",
        "a": "Yes. We offer standalone logo design as well as complete branding packages."
      },
      {
        "q": "Can you redesign our existing brand?",
        "a": "Absolutely. Our rebranding services help modernize your business while maintaining brand recognition."
      },
      {
        "q": "Why is branding important?",
        "a": "Strong branding builds trust, increases recognition, improves customer loyalty, and supports long-term business growth."
      }
    ],
    "cta": {
      "eyebrow": "Final CTA",
      "title": "Ready to Build a Brand That Customers Remember?",
      "desc": "Whether you're launching a new business or refreshing an existing identity, Azaziya delivers branding solutions that create lasting impressions and measurable business value. Let's create a brand your customers will remember.",
      "btnText": "Get Your Free Branding Consultation Today",
      "btnLink": "/contact"
    }
  },
  "social-media": {
    "eyebrow": "Service 02 - Social Media Marketing",
    "title": "Performance-Focused Social Media Marketing in Dubai, UAE",
    "lead": "Azaziya is a leading social media marketing agency in Dubai helping brands grow faster through data-driven strategies, creative storytelling, and high-converting campaigns. We partner with startups and enterprise companies to build powerful digital presence and generate measurable business results.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "Social Media Marketing",
    "ctaLabel": "Get Your Free Quote",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/social-media-marketing",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "",
    "pricePlanImage": "",
    "whyItMatters": {
      "eyebrow": "Why Choose Us",
      "title": "Why Choose Azaziya Social Media Agency UAE?",
      "description": "In a competitive market like Dubai, your business needs more than just posting - it needs a strategic growth engine. We position your brand where your customers are, and convert attention into revenue.",
      "checks": [
        "ROI-focused social media marketing strategies",
        "Deep understanding of UAE market trends & audience behavior",
        "Platform-specific expertise (Instagram, Facebook, LinkedIn, TikTok)",
        "Conversion-driven campaigns (leads, sales, brand growth)",
        "Transparent reporting with performance analytics"
      ],
      "cards": []
    },
    "ourServices": {
      "eyebrow": "Our Services",
      "title": "Our Social Media Marketing Services in Dubai",
      "cards": [
        {
          "num": "01",
          "title": "Social Media Management Dubai",
          "desc": "Our expert team handles complete account management to ensure consistent growth and engagement.",
          "bullets": [
            "Content calendar & strategy planning",
            "Professional post design & copywriting",
            "Daily posting & audience engagement",
            "Hashtag strategy & trend optimization"
          ]
        },
        {
          "num": "02",
          "title": "Social Media Advertising Agency Dubai",
          "desc": "Accelerate your growth with our performance-driven paid campaigns. We optimize every campaign to maximize ROI and reduce cost per acquisition.",
          "bullets": [
            "Facebook Ads & Instagram Ads",
            "TikTok Ads & LinkedIn Ads",
            "Lead generation campaigns",
            "Conversion & retargeting funnels"
          ]
        },
        {
          "num": "03",
          "title": "Content Creation & Branding",
          "desc": "We create content that captures attention and builds brand authority.",
          "bullets": [
            "Social media content creation Dubai",
            "Short-form video (Reels, TikTok)",
            "Brand storytelling & visual identity",
            "Creative campaign execution"
          ]
        },
        {
          "num": "04",
          "title": "Platform-Specific Marketing",
          "desc": "Every platform requires a unique approach. We specialize in:",
          "bullets": [
            "Instagram Marketing Dubai",
            "Facebook Marketing Dubai",
            "LinkedIn Marketing UAE (B2B)",
            "TikTok Marketing UAE"
          ]
        }
      ]
    },
    "sectors": {
      "eyebrow": "Industries",
      "title": "Industries We Serve in UAE",
      "description": "We tailor strategies according to your industry, audience, and business goals.",
      "tags": [
        "Real Estate Companies",
        "E-commerce Brands",
        "Restaurants & Cafés",
        "Healthcare Clinics",
        "Corporate & B2B Businesses",
        "Startups & Entrepreneurs"
      ]
    },
    "process": {
      "eyebrow": "How We Work",
      "title": "Our Proven Process",
      "description": "We follow a structured, data-driven approach - this ensures long-term success and consistent growth.",
      "steps": [
        {
          "_key": "process-step-0",
          "desc": "Understanding the competitive landscape before building your strategy.",
          "num": "01",
          "title": "Market & Competitor Analysis"
        },
        {
          "_key": "process-step-1",
          "desc": "A plan built around your goals, audience, and budget.",
          "num": "02",
          "title": "Custom Strategy Development"
        },
        {
          "_key": "process-step-2",
          "desc": "Building the calendar, creative assets, and copy.",
          "num": "03",
          "title": "Content Planning & Creation"
        },
        {
          "_key": "process-step-3",
          "desc": "Publishing, promoting, and actively managing every channel.",
          "num": "04",
          "title": "Campaign Launch & Management"
        },
        {
          "_key": "process-step-4",
          "desc": "Continuous refinement based on real performance data.",
          "num": "05",
          "title": "Performance Tracking & Optimization"
        }
      ]
    },
    "split": {
      "leftEyebrow": "Affordable Packages",
      "leftTitle": "Affordable Social Media Marketing Dubai for Businesses",
      "leftDesc": "Whether you are a startup or an established brand, Azaziya offers affordable social media marketing Dubai packages designed to deliver maximum ROI. We help you:",
      "leftBullets": [
        "Increase brand awareness",
        "Generate high-quality leads",
        "Drive consistent sales"
      ],
      "rightEyebrow": "2026 Outlook",
      "rightTitle": "Why Social Media Marketing Matters in Dubai (2026)",
      "rightDesc": "Dubai is one of the most competitive digital markets. Without a strong presence, businesses lose opportunities daily. With Azaziya's social media marketing services UAE, you can reach targeted, high-intent audiences, build brand authority, increase engagement & conversions, and stay ahead of competitors."
    },
    "faqsTitle": "FAQs – Social Media Marketing Dubai",
    "faqsEyebrow": "FAQs",
    "faqs": [
      {
        "q": "How much does social media marketing cost in Dubai?",
        "a": "Pricing depends on your goals, platforms, and campaign scale. We offer flexible packages for all business sizes."
      },
      {
        "q": "How long does it take to see results?",
        "a": "Organic social media marketing typically takes 2–3 months to show strong results, while paid advertising campaigns can start generating leads and sales within a few days."
      },
      {
        "q": "Which platform is best for my business?",
        "a": "The best platform depends on your business type. Instagram and Facebook work well for B2C brands, while LinkedIn is ideal for B2B businesses in the UAE market."
      },
      {
        "q": "Do you offer social media advertising services in Dubai?",
        "a": "Yes, Azaziya provides expert social media advertising services including Facebook Ads, Instagram Ads, TikTok Ads, and LinkedIn Ads focused on lead generation and conversions."
      },
      {
        "q": "Can social media marketing help small businesses in Dubai?",
        "a": "Absolutely. Social media marketing is one of the most effective ways for small businesses in Dubai to build brand awareness, attract customers, and increase sales with a limited budget."
      },
      {
        "q": "What industries do you serve in UAE?",
        "a": "Azaziya works with real estate, e-commerce, restaurants, healthcare, corporate businesses, and startups across Dubai and Saudi Arabia."
      }
    ],
    "cta": {
      "eyebrow": "Get Started",
      "title": "Looking for the Best Social Media Marketing Agency in Dubai?",
      "desc": "Azaziya is your growth partner. Contact us today to get a customized strategy and scale your business with confidence.",
      "btnText": "Click for Free Quote",
      "btnLink": "/contact"
    },
    "whyUs": {
      "checks": []
    }
  },
  "web-development": {
    "eyebrow": "Service 03 - Web Development",
    "title": "Build High-Performance Websites That Drive Traffic, Leads and Sales",
    "lead": "Azaziya is a top web development company specialising in fast, SEO-optimised and conversion-focused websites designed to grow your business online. With over 10 years of experience, our team delivers custom-built solutions that combine modern design, advanced technology and performance-driven execution.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "Web Development",
    "ctaLabel": "Get a Free Consultation",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/web-development",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "",
    "pricePlanImage": "",
    "whyItMatters": {
      "eyebrow": "Custom Development",
      "title": "Custom Web Development Services in Dubai",
      "description": "We provide complete website development solutions tailored to your business goals in the UAE market. Each website is built to be responsive, secure and fully optimised for search engines.",
      "cards": [
        {
          "_key": "whyItMatters-card-0",
          "desc": "Bespoke builds designed around your business, not a template.",
          "title": "Custom Website Development"
        },
        {
          "_key": "whyItMatters-card-1",
          "desc": "Professional sites that establish credibility and authority.",
          "title": "Corporate & Business Websites"
        },
        {
          "_key": "whyItMatters-card-2",
          "desc": "Shopify and WooCommerce stores built to convert.",
          "title": "E-commerce Development"
        },
        {
          "_key": "whyItMatters-card-3",
          "desc": "High-converting pages built for lead generation campaigns.",
          "title": "Landing Pages for Ads"
        },
        {
          "_key": "whyItMatters-card-4",
          "desc": "Easy-to-manage sites on the platform that fits your team.",
          "title": "WordPress & CMS Development"
        },
        {
          "_key": "whyItMatters-card-5",
          "desc": "Modernise and accelerate an existing site.",
          "title": "Website Redesign & Speed Optimisation"
        }
      ]
    },
    "split": {
      "eyebrow": "Performance First",
      "title": "Fast, SEO-Optimised and Conversion-Focused Websites",
      "description": "At Azaziya, we focus on building websites that perform, rank and convert. Our approach ensures your website delivers measurable business results.",
      "checks": [
        "Fast loading speed optimised for Core Web Vitals",
        "SEO-friendly website structure for higher rankings",
        "Mobile-first and fully responsive design",
        "Conversion-focused UI/UX to increase leads and sales",
        "Secure and scalable development"
      ]
    },
    "whyUs": {
      "eyebrow": "Why Azaziya",
      "title": "Why Choose Azaziya as Your Web Development Company.",
      "description": "Choosing the right web development partner is critical for long-term success. We follow EEAT principles to build trust, authority, and long-term rankings.",
      "checks": [
        "10+ years of professional experience",
        "Skilled developers and SEO specialists",
        "Proven results with UAE-based businesses",
        "Latest technologies and frameworks",
        "Transparent communication and support"
      ]
    },
    "roi": {
      "eyebrow": "ROI",
      "title": "Performance-Driven Development That Delivers ROI",
      "description": "We build websites with a clear focus on business growth. Every project is aligned with your business objectives.",
      "checks": [
        "Increase organic traffic through SEO optimisation",
        "Improve user engagement and retention",
        "Generate high-quality leads",
        "Maximise conversions and revenue"
      ]
    },
    "sectors": {
      "eyebrow": "Coverage",
      "title": "Serving Businesses Across Dubai and Saudi Arabia",
      "description": "Azaziya works with clients across Dubai, Abu Dhabi, Sharjah, and all Emirates. We create tailored solutions for every industry to help businesses stand out in a competitive digital landscape.",
      "tags": [
        "Dubai",
        "Abu Dhabi",
        "Sharjah",
        "Ajman",
        "Ras Al Khaimah",
        "Fujairah",
        "Umm Al Quwain"
      ]
    },
    "cta": {
      "eyebrow": "Trusted Results",
      "title": "A Trusted Web Development Agency Built on Results",
      "desc": "Our development process is backed by real experience, proven strategies and continuous optimisation. Contact Azaziya today to build a fast, SEO-optimised, and conversion-focused website for your business in Dubai.",
      "btnText": "Get a Free Consultation",
      "btnLink": "/contact"
    },
    "process": {
      "steps": []
    }
  },
  "3d-event-design": {
    "eyebrow": "Service 04 - 3D exhibition & Event Design",
    "title": "3D exhibition & Event Designer Dubai | Exhibition Stand & Event Design UAE",
    "lead": "See Your Exhibition Stand Before It Gets Built. Our photorealistic 3D designs show every detail lighting, materials, branding, graphics, and visitor flow so you know exactly what will be built before production starts.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "3D exhibition & Event Design",
    "ctaLabel": "Request Your Free 3D Consultation",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/3d-event-exhibition",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "/files/price-plan-branding.pdf",
    "pricePlanImage": "/images/price-plan-branding.jpg",
    "whyItMatters": {
      "eyebrow": "Design It Right, First",
      "title": "Why Businesses Choose Azaziya as Their 3D exhibition & Event Designer in Dubai",
      "description": "Successful exhibitions are planned long before the event opens. Our visualization process helps eliminate expensive mistakes by allowing you to see the finished project before fabrication begins. Our designs have supported businesses exhibiting at major venues including Dubai World Trade Centre, Expo City Dubai, ADNEC Abu Dhabi, and Sharjah Expo Centre.",
      "checks": [
        "Photorealistic 3D event visualizations",
        "Exhibition stand concepts designed around visitor engagement",
        "Accurate material, lighting, and branding previews",
        "Multiple design revisions before production",
        "Production-ready files for fabrication teams",
        "Optional fabrication coordination and installation support"
      ],
      "cards": []
    },
    "ourServices": {
      "eyebrow": "Our Services",
      "title": "Our 3D exhibition & Event Design Services",
      "cards": [
        {
          "title": "3D Exhibition Stand Design",
          "desc": "Complete 3D visualization before fabrication, reviewing layouts, branding, product displays, meeting areas, and lighting from every angle.",
          "bullets": [
            "Photorealistic 3D renders",
            "Custom booth concepts",
            "Brand colour integration",
            "Production-ready files"
          ]
        },
        {
          "title": "Event Stage Design",
          "desc": "Complete event stages in 3D for conferences, product launches, award ceremonies, and investor summits.",
          "bullets": [
            "LED screen positioning",
            "Stage backdrops",
            "Lighting concepts",
            "Branding placement"
          ]
        },
        {
          "title": "Trade Show Booth Design",
          "desc": "Booths designed to encourage visitors to stop, engage, and start conversations.",
          "bullets": [
            "Visitor movement",
            "Product visibility",
            "Meeting areas",
            "Lead generation zones"
          ]
        },
        {
          "title": "Brand Activation & Experiential Design",
          "desc": "Immersive 3D environments for pop-ups, product launches, and experiential marketing installations.",
          "bullets": [
            "One approved visual reference",
            "Reduced delays",
            "Aligned marketing vision"
          ]
        },
        {
          "title": "Event Graphics & Environmental Branding",
          "desc": "Large-format graphics reviewed at real-world scale before printing.",
          "bullets": [
            "Stage graphics",
            "LED screen content",
            "Directional signage",
            "Entrance features"
          ]
        },
        {
          "title": "Why 3D Visualization Matters",
          "desc": "Most event problems happen weeks before installation - incorrect logo placement, tight meeting areas, blocked entrances, poor lighting. We catch these before fabrication begins."
        }
      ]
    },
    "sectors": {
      "eyebrow": "Industries",
      "title": "Industries We Work With",
      "tags": [
        "Technology",
        "Healthcare",
        "Construction",
        "Government",
        "Hospitality",
        "Real Estate",
        "Retail",
        "Education",
        "Manufacturing",
        "Finance"
      ]
    },
    "process": {
      "eyebrow": "How We Work",
      "title": "Our Design Process",
      "outro": "Typical turnaround: 5–10 working days. Rush projects are available depending on availability.",
      "steps": [
        {
          "_key": "process-step-0",
          "desc": "Share your booth size, venue, event details, brand guidelines, and objectives.",
          "num": "01",
          "title": "Project Brief"
        },
        {
          "_key": "process-step-1",
          "desc": "Our designers create an initial 3D concept that reflects your brand and event goals.",
          "num": "02",
          "title": "Concept Development"
        },
        {
          "_key": "process-step-2",
          "desc": "High-quality 3D renders showing the complete event environment from multiple perspectives.",
          "num": "03",
          "title": "Photorealistic Rendering"
        },
        {
          "_key": "process-step-3",
          "desc": "Your feedback is incorporated until the design meets your expectations.",
          "num": "04",
          "title": "Review & Revisions"
        },
        {
          "_key": "process-step-4",
          "desc": "Fabrication-ready files delivered, with direct coordination with your production team if required.",
          "num": "05",
          "title": "Production Ready"
        }
      ]
    },
    "coverage": {
      "eyebrow": "Coverage",
      "title": "Areas We Serve",
      "description": "We provide 3D exhibition & Event Design services throughout the UAE, and also work remotely with international businesses exhibiting across the UAE.",
      "tags": [
        "Dubai",
        "Abu Dhabi",
        "Sharjah",
        "Ajman",
        "Ras Al Khaimah",
        "Fujairah",
        "Umm Al Quwain",
        "Al Ain"
      ]
    },
    "cta": {
      "eyebrow": "Ready to Visualize Your Next Event?",
      "title": "Design It Right Before You Build It.",
      "desc": "Whether you need a custom exhibition stand, trade show booth, corporate stage, or experiential brand activation, Azaziya helps you visualize the finished result before production begins.",
      "btnText": "Request Your Free 3D Event Consultation",
      "btnLink": "/contact"
    },
    "whyUs": {
      "checks": []
    }
  },
  "video-animation": {
    "eyebrow": "Service 05 - Video Animation",
    "title": "Bring Your Ideas to Life with High-Impact Animation",
    "lead": "In a competitive digital landscape like Dubai, brands need more than static visuals to stand out. We create powerful video animation solutions that transform your ideas into engaging visual experiences - to capture attention, communicate clearly, and convert viewers into customers.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "Video Animation",
    "ctaLabel": "Get a Free Quote",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/video-animation",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "",
    "pricePlanImage": "",
    "metrics": {
      "eyebrow": "Results-Driven Animation",
      "title": "Animation Built Around Business Outcomes, Not Just Visuals",
      "statVal": "70%",
      "statDesc": "Increase in audience engagement",
      "cards": [
        {
          "title": "Brand Recall",
          "desc": "Boost brand awareness and recall across every touchpoint."
        },
        {
          "title": "Conversions",
          "desc": "Improve conversion rates on landing pages and ads."
        },
        {
          "title": "Clarity",
          "desc": "Simplify complex products or services into clear stories."
        }
      ]
    },
    "ourServices": {
      "eyebrow": "Leading Animation Agency",
      "title": "Custom Projects - Never Templates",
      "description": "Azaziya is recognized as a trusted animation company, delivering high-quality, custom animation projects tailored to each client. Every project is built from scratch with a focus on brand identity, target audience behavior, marketing goals, and platform optimization.",
      "cards": [
        {
          "num": "01",
          "title": "2D Animation Videos",
          "desc": "Engaging and cost-effective animations perfect for explainer videos, ads, and brand storytelling."
        },
        {
          "num": "02",
          "title": "3D Animation Services UAE",
          "desc": "High-end, realistic visuals ideal for real estate, product visualization, and exhibitions."
        },
        {
          "num": "03",
          "title": "Motion Graphics Design",
          "desc": "Dynamic animations for social media campaigns, ads, and digital branding."
        },
        {
          "num": "04",
          "title": "Explainer Video Production",
          "desc": "Simplify complex concepts into easy-to-understand and engaging visual stories."
        },
        {
          "num": "05",
          "title": "Corporate Animation Videos",
          "desc": "Professional animation content for presentations, training, and corporate communication."
        }
      ]
    },
    "whyUs": {
      "eyebrow": "Why Choose Us",
      "title": "Why Choose Azaziya for Animation in Dubai?",
      "checks": [
        "UAE-focused creative & marketing team",
        "Strategy-driven animation (not just design)",
        "Fast turnaround time",
        "100% custom solutions",
        "Proven results across multiple industries"
      ]
    },
    "sectors": {
      "eyebrow": "Industries",
      "title": "Industries We Serve",
      "tags": [
        "Real Estate & Developers",
        "Events & Exhibitions",
        "E-commerce & Retail",
        "Corporate & B2B Businesses",
        "Healthcare & Education",
        "Tech & Startups"
      ]
    },
    "faqsTitle": "FAQs – Video Animation Dubai",
    "faqsEyebrow": "FAQs",
    "faqs": [
      {
        "q": "How much does animation cost in Dubai?",
        "a": "Costs depend on animation type, duration, and complexity. We provide custom pricing based on your project."
      },
      {
        "q": "How long does it take to create a video animation?",
        "a": "Typically 1–3 weeks depending on the scope and revisions."
      },
      {
        "q": "What is the difference between 2D and 3D animation?",
        "a": "2D is ideal for storytelling and explainer videos, while 3D is used for realistic visuals and product showcases."
      },
      {
        "q": "Do you provide complete animation services?",
        "a": "Yes, including scripting, voiceover, animation, and final delivery."
      },
      {
        "q": "Can animation improve conversions?",
        "a": "Yes, animation significantly increases engagement, clarity, and conversion rates."
      }
    ],
    "cta": {
      "eyebrow": "Start Your Animation Project Today",
      "title": "Turn Your Vision Into High-Converting Visuals",
      "desc": "Get a free consultation, receive a custom animation strategy, and elevate your brand with professional video animation services in Dubai, UAE.",
      "btnText": "Get a Free Consultation",
      "btnLink": "/contact"
    },
    "whyItMatters": {
      "cards": []
    },
    "process": {
      "steps": []
    }
  },
  "seo": {
    "eyebrow": "Service 06 - SEO & AEO Services",
    "title": "Performance-Focused SEO & AEO Company",
    "lead": "Your customers are searching for your products and services every day. The question is, are they finding your business or your competitors? We combine traditional SEO with Answer Engine Optimisation (AEO) and Local SEO to ensure your business is visible wherever customers search.",
    "breadcrumbParentText": "Services",
    "breadcrumbParentLink": "/services",
    "breadcrumbText": "SEO & AEO",
    "ctaLabel": "Book Your Free SEO Audit",
    "portfolioText": "View Portfolio",
    "portfolioLink": "/portfolio/seo",
    "pricePlanLabel": "Price Plan",
    "pricePlanPdf": "",
    "pricePlanImage": "",
    "whyUs": {
      "eyebrow": "Why Azaziya",
      "title": "Why Businesses Choose Azaziya as Their SEO Partner",
      "description": "SEO has changed dramatically. Ranking for a few keywords is no longer enough. Modern search engines prioritize businesses that demonstrate expertise, authority, trust, and user experience. Our mission is simple: increase your visibility, generate more leads, grow your business.",
      "checks": [
        "Comprehensive SEO Strategy",
        "Advanced Technical SEO Optimization",
        "Local SEO for Dubai & UAE",
        "AI & Answer Engine Optimization (AEO)",
        "High-Quality Content Strategy",
        "On-Page & Off-Page SEO",
        "Competitor Research & Gap Analysis",
        "Monthly Reporting with Transparent Results",
        "Continuous Performance Monitoring"
      ]
    },
    "splitAudit": {
      "eyebrow": "Free SEO Audit Available",
      "title": "Want to Know Why Your Competitors Outrank You?",
      "description": "Our SEO experts will perform a comprehensive website audit, identify technical issues, keyword opportunities, content gaps, and growth potential - completely free.",
      "btnText": "Book Your Free SEO Audit Today",
      "btnLink": "/contact"
    },
    "ourServices": {
      "eyebrow": "Complete SEO Services",
      "title": "Everything Under One Roof",
      "description": "Every business has unique goals. That's why we create customized SEO strategies instead of using one-size-fits-all packages.",
      "cards": [
        {
          "num": "01",
          "title": "Search Engine Optimization",
          "desc": "We optimize technical SEO, on-page optimization, keyword targeting, content structure, internal linking, metadata, Core Web Vitals, and website performance to maximize search visibility."
        },
        {
          "num": "02",
          "title": "Answer Engine Optimization (AEO)",
          "desc": "AI-powered search is transforming how users find information. We optimize for featured snippets, AI-generated answers, conversational search, FAQs, structured data, and semantic search."
        },
        {
          "num": "03",
          "title": "Local SEO",
          "desc": "If customers are searching \"near me\" or within Dubai and Saudi Arabia, your business needs strong local visibility.",
          "bullets": [
            "Google Business Profile optimization",
            "Local keyword targeting",
            "Citation management",
            "Location landing pages",
            "Local link building",
            "Review optimization",
            "Google Maps ranking improvements"
          ]
        }
      ]
    },
    "process": {
      "eyebrow": "How We Work",
      "title": "Our SEO Process",
      "description": "We follow a structured, transparent process that produces measurable results.",
      "steps": [
        {
          "_key": "process-step-0",
          "desc": "Understanding your business, competitors, current rankings, technical issues, and growth opportunities.",
          "num": "01",
          "title": "SEO Audit & Discovery"
        },
        {
          "_key": "process-step-1",
          "desc": "Identifying high-converting commercial keywords, local search opportunities, and informational topics.",
          "num": "02",
          "title": "Keyword Research"
        },
        {
          "_key": "process-step-2",
          "desc": "Improving website architecture, content, technical performance, metadata, page speed, and internal linking.",
          "num": "03",
          "title": "Website Optimization"
        },
        {
          "_key": "process-step-3",
          "desc": "Strengthening online authority through ethical link-building, digital PR, and content marketing.",
          "num": "04",
          "title": "Authority Building"
        },
        {
          "_key": "process-step-4",
          "desc": "Monitoring rankings, traffic, user behavior, conversions, and algorithm updates while refining the campaign.",
          "num": "05",
          "title": "Reporting & Continuous Improvement"
        }
      ]
    },
    "sectors": {
      "eyebrow": "Industries",
      "title": "Industries We Serve",
      "tags": [
        "Healthcare & Medical Clinics",
        "Real Estate",
        "Construction Companies",
        "Law Firms",
        "Hospitality",
        "Restaurants & Cafes",
        "eCommerce Stores",
        "Education & Training",
        "Automotive",
        "Finance & Insurance",
        "Home Services",
        "Beauty & Wellness",
        "Technology",
        "Corporate Businesses",
        "Professional Services"
      ]
    },
    "splitValue": {
      "leftEyebrow": "Long-Term Value",
      "leftTitle": "Why SEO Is One of the Best Investments for Your Business",
      "leftDesc": "Unlike paid advertising that stops generating traffic the moment you pause your budget, SEO continues to deliver long-term value. A properly optimized website attracts consistent organic visitors, builds trust, reduces customer acquisition costs, and generates leads around the clock.",
      "rightEyebrow": "Why Azaziya",
      "rightTitle": "Transparency, Data, and Long-Term Partnerships",
      "rightDesc": "We don't rely on shortcuts or risky SEO practices. Instead, we build search strategies based on data, experience, and proven methodologies that comply with Google's best practices from technical optimization to AI search readiness."
    },
    "faqsTitle": "Frequently Asked Questions",
    "faqsEyebrow": "FAQs",
    "cta": {
      "eyebrow": "Ready to Grow Your Business?",
      "title": "Get Your FREE SEO Audit Today",
      "desc": "Discover what's holding your website back, uncover hidden growth opportunities, and receive expert recommendations with no obligation.",
      "btnText": "Get Your Free SEO Audit",
      "btnLink": "/contact"
    },
    "whyItMatters": {
      "cards": []
    }
  }
};

export const blogsDetailData = [
  {
    "id": "branding",
    "category": "Branding",
    "readTime": "6 min read",
    "title": "Why Your Brand Is More Than a Logo",
    "lead": "A logo is one piece of a bigger system. Here's what actually builds recognition and trust with UAE customers.",
    "tag": "Branding",
    "image": "https://cdn.sanity.io/images/9u1ix3zs/production/81a35739a468fa13a636309a9435d56dfcdaeeb6-2816x1536.jpg",
    "link": "/blog/branding",
    "breadcrumbText": "Why Your Brand Is More Than a Logo",
    "breadcrumbParentText": "Blog",
    "breadcrumbParentLink": "/blog",
    "sections": [
      {
        "_key": "a0a23dc37329",
        "heading": "The Logo Is the Signature, Not the Story",
        "paragraphs": [
          "Most business owners start a branding conversation by asking for a logo. It's the most visible piece, so it feels like the whole job. In practice, a logo is closer to a signature than a story it identifies you, but it doesn't explain why anyone should care.\n\nWhat actually drives recognition and trust is the full system behind that mark: a clear positioning, a consistent visual language, and a message that stays the same across every touchpoint a customer sees, from your website to your business card to your Instagram grid."
        ]
      },
      {
        "_key": "a7d41a23019e"
      }
    ],
    "cta": {
      "heading": "Ready to Build the Full System, Not Just a Logo?",
      "text": "Our branding team starts with strategy and ends with a complete, consistent identity your business can grow into.",
      "btnText": "Explore Branding Services",
      "btnLink": "/services/branding"
    }
  }
];

export const faqsData = [
  {
    "q": "What is included in branding services?",
    "a": "Branding services typically include brand strategy, logo design, visual identity, messaging, brand guidelines, and marketing assets.",
    "category": "branding"
  },
  {
    "q": "How long does a branding project take?",
    "a": "Most branding projects are completed within 2–6 weeks, depending on the scope and complexity.",
    "category": "branding"
  },
  {
    "q": "Do you provide logo design only?",
    "a": "We offer standalone logo design as well as complete branding packages.",
    "category": "branding"
  },
  {
    "q": "Can you redesign our existing brand?",
    "a": "Absolutely. Our rebranding services help modernize your identity while preserving the trust you've already built.",
    "category": "branding"
  }
];

export const portfolioData = {
  "hero": {
    "breadcrumbText": "Portfolio",
    "eyebrow": "Our Work",
    "heading": "Six Portfolios That Showcase Creative and Digital Excellence.",
    "lead": "From conceptual designs in worldwide launches, explore how Azaziya helps businesses grow with state-of-the-art designs, precision code, and performance marketing."
  },
  "ctaBand": {
    "eyebrow": "Ready to Collaborate?",
    "heading": "Let's build something exceptional for your brand.",
    "btnText": "Start a Project",
    "btnLink": "/contact"
  },
  "items": [
    {
      "num": "01",
      "title": "3D exhibition & Event Design",
      "subtitle": "SPATIAL EXPERIENCES",
      "tagline": "VIEW WORK",
      "link": "/portfolio/3d-event-design",
      "eyebrow": "Our Portfolio",
      "heading": "3D exhibition & Event Design",
      "lead": "Photorealistic 3D visualisations of exhibition stands, stages, and booths before fabrication begins.",
      "intro": "We turn complex spatial concepts into tangible, photorealistic 3D renders that ensure complete clarity before production.",
      "capabilities": [
        "3D Exhibition Stand Design",
        "Event Stage Design",
        "Trade Show Booth Design",
        "Brand Activation Designs"
      ],
      "gallery": []
    },
    {
      "num": "02",
      "title": "Web Development",
      "subtitle": "DIGITAL PLATFORMS",
      "tagline": "VIEW WORK",
      "link": "/portfolio/web-development",
      "eyebrow": "Our Portfolio",
      "heading": "Web Development Projects",
      "lead": "Fast, SEO-optimised, conversion-focused websites corporate, e-commerce, landing pages, and CMS.",
      "intro": "High-performance digital experiences built with modern frontend tools, custom code, and CMS integrations.",
      "capabilities": [
        "Custom Website Development",
        "E-commerce (Shopify, WooCommerce)",
        "Landing Pages for Ads",
        "Website Redesign & Speed Optimisation"
      ],
      "gallery": []
    },
    {
      "num": "03",
      "title": "Branding Services",
      "subtitle": "VISUAL IDENTITIES",
      "tagline": "VIEW WORK",
      "link": "/portfolio/branding",
      "eyebrow": "Our Portfolio",
      "heading": "Branding & Brand Identity",
      "lead": "Brand strategy, logo design, visual identity systems, brand guidelines, corporate branding, and rebranding.",
      "intro": "We craft distinct visual systems and memorable brand identities designed to build trust and recognition.",
      "capabilities": [
        "Brand Strategy & Positioning",
        "Logo & Visual Identity",
        "Brand Guidelines",
        "Corporate & Rebranding"
      ],
      "gallery": []
    },
    {
      "num": "04",
      "title": "Video Animation",
      "subtitle": "MOTION & 3D",
      "tagline": "VIEW WORK",
      "link": "/portfolio/video-animation",
      "eyebrow": "Our Portfolio",
      "heading": "Video Animation & Motion Graphics",
      "lead": "2D & 3D animation, motion graphics, explainer, and corporate videos built from scratch.",
      "intro": "Dynamic visual stories and high-impact motion assets crafted to communicate complex ideas effortlessly.",
      "capabilities": [
        "2D Animation Videos",
        "3D Animation Services",
        "Motion Graphics Design",
        "Explainer Video Production"
      ],
      "gallery": []
    },
    {
      "num": "05",
      "title": "Social Media Marketing",
      "subtitle": "DIGITAL CAMPAIGNS",
      "tagline": "VIEW WORK",
      "link": "/portfolio/digital-marketing",
      "eyebrow": "Our Portfolio",
      "heading": "Social Media Marketing & Paid Advertising",
      "lead": "ROI-driven strategy, management, advertising, and content creation across every major platform.",
      "intro": "Performance-focused social media campaigns built to convert audiences, build brand equity, and generate sales across Dubai and the UAE.",
      "capabilities": [
        "Social Media Management",
        "Paid Social Advertising",
        "Content Creation & Branding",
        "Platform-Specific Marketing"
      ],
      "gallery": []
    },
    {
      "num": "06",
      "title": "SEO & AEO Solutions",
      "subtitle": "SEARCH & AI DISCOVERY",
      "tagline": "VIEW WORK",
      "link": "/portfolio/seo-ai-solutions",
      "eyebrow": "Our Portfolio",
      "heading": "SEO & Answer Engine Optimisation",
      "lead": "Technical SEO, Local SEO, and Answer Engine Optimisation for Google and AI-powered search engines.",
      "intro": "Strategic visibility campaigns designed to get your business found, ranked, and cited across traditional Google search and modern AI answer platforms.",
      "capabilities": [
        "Technical SEO Auditing & Crawl Fixes",
        "Local Search & Maps Optimization",
        "Answer Engine Optimization (AEO)",
        "Keyword Research & Competitor Analysis",
        "Authority & High-Quality Link Building",
        "SEO Content & Blog Strategy"
      ],
      "gallery": []
    }
  ]
};

